import React, { useEffect, useState } from "react";
import {
  getProductComments,
  toggleCommentStatus,
} from "../../../services/apiService";
import { showSnackbar } from "../../../comopnents/snackbar";

const ProductComments = () => {
  const [comments, setComments] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    fetchComments();
  }, []);

  const fetchComments = async () => {
    try {
      const res = await getProductComments();
      console.log("API RESPONSE:", res.data);
      console.log("COMMENTS ARRAY:", res.data?.Data);
      setComments(res.data?.Data || []);
    } catch (error) {
      console.error("API Error:", error);
      setComments([]);
    }
  };
  const handleToggle = async (item) => {
    try {
      const newStatus = item.active === 1 ? 0 : 1;

      const res = await toggleCommentStatus(item.cid, newStatus);

      // ✅ update UI immediately
      setComments((prev) =>
        prev.map((c) => (c.cid === item.cid ? { ...c, active: newStatus } : c)),
      );

      // ✅ success snackbar
      showSnackbar(
        "success",
        res?.data?.message ||
          `Comment ${newStatus === 1 ? "activated" : "deactivated"} successfully`,
      );
    } catch (error) {
      console.error("Failed to toggle status:", error);

      // ❌ error snackbar
      showSnackbar(
        "error",
        error?.response?.data?.message || "Failed to update comment status",
      );
    }
  };

  const filtered = comments.filter(
    (c) =>
      (c.email && c.email.toLowerCase().includes(search.toLowerCase())) ||
      (c.modelno && c.modelno.toLowerCase().includes(search.toLowerCase())),
  );

  const totalPages = Math.ceil(filtered.length / pageSize);
  const paginatedData = filtered.slice((page - 1) * pageSize, page * pageSize);

  return (
    <div className="comment-wrapper">
      <h3 className="title">Comments</h3>

      {/* Search */}
      <div className="search-box">
        <input
          type="text"
          placeholder="Search by email or model"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
      </div>

      {/* Debug info */}
      <div style={{ fontSize: "12px", color: "#666", marginBottom: "10px" }}>
        Total comments: {comments.length} | Filtered: {filtered.length} |
        Showing: {paginatedData.length}
      </div>

      {/* Table */}
      <table className="comment-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Comment ID</th>
            <th>Product ID</th>
            <th>Email</th>
            <th>Model</th>
            <th>Date</th>
            <th>Comment</th>
            <th>Rating</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((item, index) => (
              <tr key={item.cid}>
                <td>{(page - 1) * pageSize + index + 1}</td>
                <td>{item.cid}</td>
                <td>{item.productid}</td>
                <td>{item.email}</td>
                <td>{item.modelno}</td>
                <td>{item.givendate}</td>
                <td>{item.comment}</td>
                <td>{item.rating}</td>
                <td>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={item.active === 1}
                      onChange={() => handleToggle(item)}
                    />
                    <span className="slider round"></span>
                  </label>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={9} style={{ textAlign: "center", padding: "20px" }}>
                {comments.length === 0
                  ? "Loading comments..."
                  : "No comments found."}
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Updated Pagination */}
      
<div className="pagination-container">


<div style={{color:"black"}}>
<select
className="page-select"
value={pageSize}
onChange={(e) => {
setPageSize(Number(e.target.value));
setPage(1);
}}
>

{[5,10,20,50].map((n)=>(
<option key={n} value={n}>
{n}
</option>
))}

</select>

</div>



<div className="page-buttons">

<button
className="page-btn"
disabled={page===1}
onClick={()=>setPage(page-1)}
>
Previous
</button>


<span className="page-count">

{page} / {totalPages || 1}

</span>


<button
className="page-btn"
disabled={page===totalPages || totalPages===0}
onClick={()=>setPage(page+1)}
>
Next
</button>

</div>


</div>

      {/* CSS */}
      <style>{`
        .comment-wrapper { 
          background: #fff; 
          padding: 20px; 
          border-radius: 8px; 
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        .title { 
          color: #005487; 
          margin-bottom: 15px; 
        
          padding-bottom: 10px;
        }
        .search-box { 
          text-align: right; 
          margin-bottom: 15px; 
        }
        .search-box input { 
          padding: 8px 12px; 
          border: 1px solid #005487; 
          border-radius: 4px; 
          width: 300px;
        }
        table { 
          width: 100%; 
          border-collapse: collapse; 
          font-size: 14px; 
          margin-bottom: 15px;
        }
        th, td { 
          padding: 12px; 
          border-bottom: 1px solid #ddd; 
          text-align: left; 
        }
        th { 
          background: #f3f4f6; 
          font-weight: 600;
        }
        tr:hover {
          background-color: #f9f9f9;
        }
 .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

/* Hide default checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ef4444; /* red for inactive */
  transition: 0.4s;
  border-radius: 20px;
}

/* The circle inside the slider */
.slider::before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

/* Checked/active state */
input:checked + .slider {
  background-color: #22c55e; /* green for active */
}

input:checked + .slider::before {
  transform: translateX(20px);
}

/* Rounded slider */
.slider.round {
  border-radius: 20px;
}

        .pagination {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #eee;
          padding-top: 15px;
          margin-top: 15px;
        }
        .items-per-page select {
          margin-left: 8px;
          padding: 4px 8px;
          border-radius: 4px;
          border: 1px solid #ccc;
        }
        .page-controls button {
          padding: 6px 12px;
          margin: 0 4px;
          border: 1px solid #ccc;
          border-radius: 4px;
          background: white;
          cursor: pointer;
        }
        .page-controls button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
};

export default ProductComments;
